import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useSeo } from "@/lib/seo";

const AdminLogin = () => {
  useSeo({ title: "Administration", noindex: true });
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "h-14 w-full rounded-md border border-clay bg-cream px-4 text-sm text-bark placeholder:text-bark/35 focus:border-terracotta focus:outline-none transition-colors duration-300";

  return (
    <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-sand px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-10 block text-center font-display text-3xl font-bold text-bark">
          Sama-<span className="italic text-terracotta">Keur</span>
        </Link>
        <form onSubmit={submit} className="border border-clay bg-cream p-10">
          <h1 className="font-display text-2xl font-semibold text-bark">Espace administrateur</h1>
          <p className="mt-2 text-sm text-bark/50">Gestion des produits et des commandes.</p>
          <div className="mt-8 space-y-4">
            <input data-testid="admin-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
            <input data-testid="admin-password-input" type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="mt-4 border border-destructive/30 bg-destructive/5 px-4 py-3 text-sm text-destructive">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            disabled={loading}
            className="mt-6 flex h-14 w-full items-center justify-center gap-3 rounded-full bg-terracotta text-sm font-bold uppercase tracking-[0.15em] text-sand transition-colors hover:bg-terracotta-dark disabled:opacity-50"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
            Se connecter
          </button>
        </form>
        <Link to="/" data-testid="admin-login-back-home" className="mt-6 block text-center text-xs font-bold uppercase tracking-[0.2em] text-bark/40 hover:text-terracotta">
          Retour à la boutique
        </Link>
      </div>
    </main>
  );
};

export default AdminLogin;
